"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _excluded = ["className"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-toolbar';
var _default = exports.default = function _default(displayName) {
  var ToolbarRegion = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    var _context, _displayName$split$;
    var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
    var _props = addChildProps ? _objectSpread(_objectSpread({}, props), addChildProps(ToolbarRegion, props)) : props;
    var className = _props.className,
      otherProps = (0, _objectWithoutProperties2.default)(_props, _excluded);
    var classnames = _bind.default.bind(_Toolbar.default);
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
      className: classnames((0, _concat.default)(_context = "".concat(CSS_BLOCK, "__")).call(_context, displayName === null || displayName === void 0 || (_displayName$split$ = displayName.split('.')[1]) === null || _displayName$split$ === void 0 ? void 0 : _displayName$split$.toLowerCase()), className),
      ref: ref
    }));
  });
  ToolbarRegion.displayName = displayName;
  ToolbarRegion.propTypes = {
    children: _propTypes.default.node.isRequired,
    className: _propTypes.default.string
  };
  return ToolbarRegion;
};